import { render, staticRenderFns } from "./screen-workOrder.vue?vue&type=template&id=72a7606d&scoped=true"
import script from "./screen-workOrder.vue?vue&type=script&lang=js"
export * from "./screen-workOrder.vue?vue&type=script&lang=js"
import style0 from "./screen-workOrder.vue?vue&type=style&index=0&id=72a7606d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7606d",
  null
  
)

export default component.exports